import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import './App.css';

import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';


import NavBar from "./components/navbar";
import Footer from './components/footer';
import Heroes from './components/heroes';
import AboutUs from './components/aboutus';
import Results from './components/results';
import Exclusions from './components/exclusions';
import TargetAudience from './components/targetaudience';
import MarketingServices from "./components/marketingservices";
import MarketingIcons from "./components/marketingicons";
import Workflow from "./components/workflow";  
//import ContactForm from "./components/contactform";
import Reviews from "./components/reviews";
import PrivacyPolicy from './components/privacypolicy'; 
import CookieBanner from './components/cookiebanner';
import ScrollToTop from './components/scrolltop';
import Pricing from './components/Pricing';

const ContactForm = lazy(() => import('./components/contactform'));

function HomePage() {
  return (
    <>
      <Heroes />
      <AboutUs />
      <Results />
      <Workflow />
      <TargetAudience />
      <Pricing />
      <Reviews />
      <Exclusions />
      <MarketingServices />
      <MarketingIcons />
      <ContactForm />
      
    </>
  );
}

function App() {
  return (
    <div className="App">
      < ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/adatvedelem" element={<PrivacyPolicy />} />
      </Routes>
      <CookieBanner />
      <Footer />
    </div>
  );
}

export default App;
